CategoriaActionsService.$inject = ['$log', 'dialogService'];

export default function CategoriaActionsService($log, dialogService) {

    var TAG = 'IncidenciaActionsService: ';

    var DIALOG_EDIT_CATEGORIA_ID = 'dialog-edit-categoria';
    var DIALOG_EDIT_CATEGORIA_TEMPLATE = require('./dialog-edit/dialog-edit-categoria.html');


    function _crearCategoria() {
        $log.debug(TAG + 'Abriendo modal para crear una nueva categoría...');

        var data = {};
        var options = {title: 'Nueva categoría'};//TODO:traducir
        var opcionesExtra = {deshabilitarBotones: true, devolverDatos: true};
        return dialogService.open(DIALOG_EDIT_CATEGORIA_ID, DIALOG_EDIT_CATEGORIA_TEMPLATE, data, options, opcionesExtra);
    }

    return {
        crearCategoria: _crearCategoria
    };
}
